import { MedRoute } from "../../../../store/types/prescription";

const MX_DOSAGE_FORM_UNIT: {
    [k: string]: {
        name: string;
        snomed_id?: string;
        unit_list: { name: string; id: string }[];
    };
} = {
    'df-2929601942': {
        name: 'tablet',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9555626637': {
        name: 'capsule',
        snomed_id: '385049006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4608470948': {
        name: 'syrup',
        snomed_id: '739009002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9889335533': {
        name: 'pill',
        snomed_id: '46992007',
        unit_list: [
            {
                name: 'pill',
                id: 'du-9889335533',
            },
            {
                name: 'granules',
                id: 'du-2425753509',
            },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7435419319': {
        name: 'injection',
        snomed_id: '385219001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6760636010': {
        name: 'inhaler',
        snomed_id: '385212005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9327400881': {
        name: 'suppository',
        snomed_id: '385195002',
        unit_list: [
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3972100204': {
        name: 'ointment',
        snomed_id: '385101003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9534413545': {
        name: 'lozenges',
        snomed_id: '385087003',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'lozenge', id: 'du-6410177996' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5140156421': {
        name: 'nasal drops',
        snomed_id: '385152001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3472438845': {
        name: 'cream',
        snomed_id: '385099005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6941042110': {
        name: 'lotion',
        snomed_id: '739000003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2069779518': {
        name: 'gel',
        snomed_id: '385100002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7737387403': {
        name: 'jelly',
        snomed_id: '764802001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5880427153': {
        name: 'vaccine',
        snomed_id: '385219001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3667869230': {
        name: 'spray',
        snomed_id: '385105007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9534758258': {
        name: 'respules',
        snomed_id: '385212005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Respule', id: 'ek-7067658814' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6169979882': {
        name: 'gargle',
        snomed_id: '385065007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2640981403': {
        name: 'tablet md',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6922544981': {
        name: 'solution for inhalation',
        snomed_id: '420641004',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771496288': {
        name: 'tablet sr',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2640981140': {
        name: 'tablet dt',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771496195': {
        name: 'tablet pr',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1673204773': {
        name: 'capsule sr',
        snomed_id: '385049006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2640981169': {
        name: 'tablet er',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6633941317': {
        name: 'dry syrup',
        snomed_id: '385026009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6712141710': {
        name: 'oral suspension',
        snomed_id: '385024007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6923115097': {
        name: 'eye drop',
        snomed_id: '385124005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-150499117': {
        name: 'shampoo',
        snomed_id: '785908001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1673204277': {
        name: 'capsule cr',
        snomed_id: '385049006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1398356916': {
        name: 'oral solution',
        snomed_id: '385023001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9603977956': {
        name: 'powder',
        snomed_id: '739005008',
        unit_list: [
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771495792': {
        name: 'tablet cr',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6938132552': {
        name: 'suspension',
        snomed_id: '739008005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1819692448': {
        name: 'transdermal patch',
        snomed_id: '385114002',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'patch', id: 'du-8947285054' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1673204339': {
        name: 'capsule er',
        snomed_id: '385049006',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1975273371': {
        name: 'mouth wash',
        snomed_id: '70409003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771496437': {
        name: 'tablet xl',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9001195403': {
        name: 'nasal spray',
        snomed_id: '385157007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6639735669': {
        name: 'solvent for injection',
        snomed_id: '385219001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9534391990': {
        name: 'respicap',
        snomed_id: '385212005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4787871768': {
        name: 'rotacap',
        snomed_id: '385212005',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9433355795': {
        name: 'tablet mr',
        snomed_id: '385061003',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5596594528': {
        name: 'ophthalmic solution',
        snomed_id: '422060001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771496443': {
        name: 'tablet xr',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4120857860': {
        name: 'oral drops',
        snomed_id: '385018001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2859918947': {
        name: 'drop',
        snomed_id: '385023001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-769375585': {
        name: 'ear drop',
        snomed_id: '385136004',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5771495978': {
        name: 'tablet ir',
        snomed_id: '385055001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-694631431': {
        name: 'sachet',
        snomed_id: '385043007',
        unit_list: [
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9785838630': {
        name: 'suspension for injection',
        snomed_id: '385220007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8590746745': {
        name: 'mouth paint',
        snomed_id: '385038000',
        unit_list: [
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1728325352': {
        name: 'eye ointment',
        snomed_id: '385123004',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2506911363': {
        name: 'vaginal cream',
        snomed_id: '385165005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2912401248': {
        name: 'oral gel',
        snomed_id: '385038000',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9961081561': {
        name: 'nasal solution',
        snomed_id: '422336005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1451863148': {
        name: 'solution',
        snomed_id: '739006009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'pump', id: 'du-5142499321' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-797376788': {
        name: 'dental gel',
        snomed_id: '385088008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-374189216': {
        name: 'infusion',
        snomed_id: '385229008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-805057610': {
        name: 'expectorant',
        snomed_id: '739009002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4924674628': {
        name: 'rectal gel',
        snomed_id: '385183002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6602885500': {
        name: 'eye gel',
        snomed_id: '385122009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7836556548': {
        name: 'soap',
        snomed_id: '429885007',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1402596922': {
        name: 'solution for infusion',
        snomed_id: '385229008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2859562306': {
        name: 'solution for injection',
        snomed_id: '385219001',
        unit_list: [
            { name: 'drop', id: 'du-6855109049' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-927090512': {
        name: 'tablet dr',
        snomed_id: '763820000',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4007097071': {
        name: 'capsule mr',
        snomed_id: '420692007',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4007096792': {
        name: 'capsule dr',
        snomed_id: '420692007',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3529236065': {
        name: 'dusting powder',
        snomed_id: '739005008',
        unit_list: [
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8217031281': {
        name: 'kit',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9993424923': {
        name: 'liquid',
        snomed_id: '739006009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1974770544': {
        name: 'eye/ear drops',
        snomed_id: '765167000',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8608641828': {
        name: 'oil',
        snomed_id: '421890007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9668524941': {
        name: 'prefilled syringe',
        snomed_id: '385220007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'prefilled syringe - unit of product usage', id: 'du-2040887171' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1688382112': {
        name: 'sublingual tablet',
        snomed_id: '764671009',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'lozenge', id: 'du-6410177996' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2185195660': {
        name: 'vaginal gel',
        snomed_id: '385166006',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1970465927': {
        name: 'transcaps',
        snomed_id: '385204002',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2643463364': {
        name: 'capsule pr',
        snomed_id: '385195002',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3441448086': {
        name: 'ophthalmic emulsion',
        snomed_id: '738998008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4850007708': {
        name: 'chewable tablet',
        snomed_id: '66076007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4857666393': {
        name: 'wipes',
        snomed_id: '385119007',
        unit_list: [
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9510666353': {
        name: 'oxipule',
        snomed_id: '385204002',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4147196478': {
        name: 'eye cream',
        snomed_id: '385121002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4780496579': {
        name: 'powder for oral suspension',
        snomed_id: '385027000',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5459446376': {
        name: 'ophthalmic gel',
        snomed_id: '385122009',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2126406054': {
        name: 'tablet vt',
        snomed_id: '385178005',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8612103017': {
        name: 'gum paint',
        snomed_id: '385023001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8208612521': {
        name: 'soflets',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8814284469': {
        name: 'toothpaste',
        snomed_id: '385039008',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-733458396': {
        name: 'rectal cream',
        snomed_id: '385182007',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4007097288': {
        name: 'capsule tr',
        snomed_id: '420692007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6628063675': {
        name: 'body wash',
        snomed_id: '385108009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1413258956': {
        name: 'film',
        snomed_id: '420460001',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2332183631': {
        name: 'effervescent tablet',
        snomed_id: '761877007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5581681612': {
        name: 'capsule xl',
        snomed_id: '385054002',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7062944040': {
        name: 'liniment',
        snomed_id: '385108009',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6899457170': {
        name: 'elixir',
        snomed_id: '738997003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5581681153': {
        name: 'capsule ir',
        snomed_id: '385054002',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9230242445': {
        name: 'vaginal capsule',
        snomed_id: '385175008',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1870425910': {
        name: 'tablet ops',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-488828760': {
        name: 'opthalmic suspension',
        snomed_id: '420736004',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-49277547': {
        name: 'linctus',
        snomed_id: '385024007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4610327408': {
        name: 'oral liquid',
        snomed_id: '385024007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2510839905': {
        name: 'bar',
        snomed_id: '429885007',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'bar', id: 'du-5372021226' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2640981634': {
        name: 'tablet tr',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4007097412': {
        name: 'capsule xr',
        snomed_id: '420692007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4579193229': {
        name: 'disintegrating strip',
        snomed_id: '764780001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2425753509': {
        name: 'granules',
        snomed_id: '385043007',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6242474875': {
        name: 'enema',
        snomed_id: '385187001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4194933531': {
        name: 'tabcap',
        snomed_id: '385054002',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8139584503': {
        name: 'vaginal spray',
        snomed_id: '426823003',
        unit_list: [
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9672058462': {
        name: 'pessaries',
        snomed_id: '385174007',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'insert', id: 'du-5546745436' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6464983615': {
        name: 'scrub',
        snomed_id: '764477003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2301953601': {
        name: 'mouth spray',
        snomed_id: '784575004',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8740451759': {
        name: 'rheocap',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2640981185': {
        name: 'tablet fc',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8561854012': {
        name: 'aquanase',
        snomed_id: '422336005',
        unit_list: [
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9502229030': {
        name: 'powder for oral solution',
        snomed_id: '385026009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8141538667': {
        name: 'oxycap',
        snomed_id: '385212005',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4132288505': {
        name: 'pellets',
        snomed_id: '420768007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-892432463': {
        name: 'powder for eye drop',
        snomed_id: '422085005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3494767737': {
        name: 'vaginal suppository',
        snomed_id: '385194003',
        unit_list: [
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5940101371': {
        name: 'opticops',
        unit_list: [
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8820373639': {
        name: 'oral jelly',
        snomed_id: '385038000',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8870357367': {
        name: 'gelatin coated tablet',
        snomed_id: '385061003',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8668057458': {
        name: 'paint',
        snomed_id: '385023001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4482240240': {
        name: 'paste',
        snomed_id: '739002006',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8035473675': {
        name: 'chewing gums',
        snomed_id: '385063000',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'gum', id: 'du-5849192778' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5915986529': {
        name: 'foam',
        snomed_id: '421166008',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'insert', id: 'du-5546745436' },
            { name: 'sponge', id: 'du-6437704872' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9712763045': {
        name: 'bottle',
        snomed_id: '739006009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7602769613': {
        name: 'novocart',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5009101888': {
        name: 'oral paste',
        snomed_id: '385039008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8095332826': {
        name: 'nexcap',
        snomed_id: '385212005',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6963584685': {
        name: 'vaginal ointment',
        snomed_id: '385167002',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'insert', id: 'du-5546745436' },
            { name: 'sponge', id: 'du-6437704872' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3938940522': {
        name: 'rectal foam',
        snomed_id: '385185009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'insert', id: 'du-5546745436' },
            { name: 'suppository', id: 'du-5850175877' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2952738396': {
        name: 'emulsion',
        snomed_id: '738998008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'can', id: 'du-6345561310' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1555529487': {
        name: 'face wash',
        snomed_id: '385108009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1277131046': {
        name: 'caplet',
        snomed_id: '420692007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2301559214': {
        name: 'particles',
        snomed_id: '385061003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4876426297': {
        name: 'ampules',
        snomed_id: '385223009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8954941358': {
        name: 'intrauterine system',
        snomed_id: '763484004',
        unit_list: [
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3624276106': {
        name: 'husk',
        snomed_id: '385041009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'scoop', id: 'du-5340101406' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-964807772': {
        name: 'pouch',
        unit_list: [
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2350212714': {
        name: 'transpules',
        snomed_id: '420641004',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7062102740': {
        name: 'diskette',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'disc', id: 'du-4662906051' },
            { name: 'pellet', id: 'du-5547400841' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6971888151': {
        name: 'redimix suspension',
        snomed_id: '739008005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4975687547': {
        name: 'autohaler',
        snomed_id: '422336005',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3659458418': {
        name: 'rediuse suspension',
        snomed_id: '739008005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9098309878': {
        name: 'redicaps',
        snomed_id: '385212005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-350518404': {
        name: 'bandage',
        snomed_id: '385114002',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1661594237': {
        name: 'powder for infusion',
        snomed_id: '765065005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5832289277': {
        name: 'gummy',
        snomed_id: '66076007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'pellet', id: 'du-5547400841' },
            { name: 'gum', id: 'du-5849192778' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7785667552': {
        name: 'nail lacquer',
        snomed_id: '385111005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8689239835': {
        name: 'pen',
        snomed_id: '769000008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'prefilled syringe - unit of product usage', id: 'du-2040887171' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9322074283': {
        name: 'pastilles',
        snomed_id: '421079001',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'pastille - unit of product usage', id: 'du-2040857374' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9055674334': {
        name: 'oral emulsion',
        snomed_id: '385025008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'glassful', id: 'du-9282413125' },
            { name: 'dropperful', id: 'du-9421805208' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'cup', id: 'du-5407263976' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2742055965': {
        name: 'combo pack',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'strip', id: 'du-9237425893' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6409891484': {
        name: 'serum',
        snomed_id: '764799005',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9556291415': {
        name: 'device',
        unit_list: [
            { name: 'kit', id: 'du-8782183332' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'stick', id: 'du-5811551420' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-5202483433': {
        name: 'rectal ointment',
        snomed_id: '385184008',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'pellet', id: 'du-5547400841' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'fingertip', id: 'du-2668366500' },
            { name: 'fingerlength', id: 'ek-3073725258' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6559745513': {
        name: 'vegicap',
        snomed_id: '420692007',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'kit', id: 'du-8782183332' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9276666923': {
        name: 'water for injection',
        snomed_id: '385219001',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'vial', id: 'du-5427001753' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3888208290': {
        name: 'aplicap',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9272193856': {
        name: 'gum',
        snomed_id: '426210003',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'gum', id: 'du-5849192778' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8601875703': {
        name: 'sublingual spray',
        snomed_id: '385073003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-8771066655': {
        name: 'cartridge',
        snomed_id: '769000008',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-9814665346': {
        name: 'intranasal spray',
        snomed_id: '385157007',
        unit_list: [
            { name: 'spray', id: 'du-8927027176' },
            { name: 'application', id: 'du-3570724545' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'drop', id: 'du-6855109049' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4627026063': {
        name: 'conditioner',
        snomed_id: '385108009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'tube', id: 'du-8005234059' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7831429544': {
        name: 'rapitab',
        snomed_id: '385061003',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7230132448': {
        name: 'patch',
        snomed_id: '739003001',
        unit_list: [
            { name: 'kit', id: 'du-8782183332' },
            { name: 'patch', id: 'du-8947285054' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3579023307': {
        name: 'aerosol',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'inhalation', id: 'du-107147167' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3342490791': {
        name: 'captab',
        snomed_id: '421026006',
        unit_list: [
            { name: 'tablet', id: 'du-5550260779' },
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-4289419884': {
        name: 'vial',
        snomed_id: '385219001',
        unit_list: [
            { name: 'vial', id: 'du-5427001753' },
            { name: 'iu', id: 'du-2393881725' },
            { name: 'ampule', id: 'du-3566047351' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-6442824734': {
        name: 'vaginal wash',
        snomed_id: '385170003',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sponge', id: 'du-6437704872' },
            { name: 'applicatorful', id: 'du-2663300367' },
            { name: 'squirt', id: 'du-950363133' },
            { name: 'applicator', id: 'du-4376237606' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-3660142317': {
        name: 'bio-adhesive',
        unit_list: [
            { name: 'application', id: 'du-3570724545' },
            { name: 'box', id: 'du-7977677380' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'patch', id: 'du-8947285054' },
            { name: 'gum', id: 'du-5849192778' },
            { name: 'package', id: 'du-7524488654' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-2103416312': {
        name: 'instacap',
        snomed_id: '385207009',
        unit_list: [
            { name: 'capsule', id: 'du-5547430628' },
            { name: 'spray', id: 'du-8927027176' },
            { name: 'puff', id: 'du-5255137469' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-7831496676': {
        name: 'autopen',
        snomed_id: '385219001',
        unit_list: [
            { name: 'iu', id: 'du-2393881725' },
            { name: 'unit', id: 'du-32223779' },
            { name: 'gm/ml', id: 'sm-3328624158' },
            { name: 'mg/ml', id: 'sm-2336653211' },
            { name: 'pint', id: 'sm-9370340185' },
            { name: 'gm', id: 'sm-2306921792' },
            { name: 'mg', id: 'sm-2306981378' },
            { name: 'mcg', id: 'sm-258685003' },
            { name: 'mcg/ml', id: 'sm-258801007' },
            { name: 'ng', id: 'sm-258686002' },
            { name: 'ng/ml', id: 'sm-258806002' },
            { name: 'mmol', id: 'sm-258718000' },
            { name: 'mmol/ml', id: 'sm-1292591000168102' },
            { name: 'mmol/l', id: 'sm-258813002' },
            { name: 'pg', id: 'sm-258687006' },
            { name: 'pg/ml', id: 'sm-258808001' },
            { name: 'mEq', id: 'sm-258727004' },
            { name: 'mEq/ml', id: 'sm-414733002' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
    'df-1846920497': {
        name: 'cleanser',
        snomed_id: '385108009',
        unit_list: [
            { name: 'ml', id: 'du-2334657215' },
            { name: 'sachet', id: 'du-3629486050' },
            { name: 'bottle', id: 'du-8925120555' },
            { name: 'packet', id: 'du-8983481126' },
            { name: 'tablespoonful', id: 'du-5397270335' },
            { name: 'teaspoonful', id: 'du-5397300121' },
            { name: 'Dose', id: 'sm-375392360' },
        ],
    },
};

export default MX_DOSAGE_FORM_UNIT;

export const FORM: { n: string }[] = Object.keys(MX_DOSAGE_FORM_UNIT).map((k) => ({
    n: MX_DOSAGE_FORM_UNIT[k].name,
}));

export const FORM_TO_DF_MAPPING: { [k: string]: string } = {
    syrup: 'df-4608470948',
    tablet: 'df-2929601942',
    capsule: 'df-9555626637',
    injection: 'df-7435419319',
    inhaler: 'df-6760636010',
    suppository: 'df-9327400881',
    ointment: 'df-3972100204',
    lozenges: 'df-9534413545',
    'nasal drops': 'df-5140156421',
    cream: 'df-3472438845',
    lotion: 'df-6941042110',
    gel: 'df-2069779518',
    jelly: 'df-7737387403',
    vaccine: 'df-5880427153',
    spray: 'df-3667869230',
    respules: 'df-9534758258',
    gargle: 'df-6169979882',
    'tablet md': 'df-2640981403',
    'solution for inhalation': 'df-6922544981',
    'tablet sr': 'df-5771496288',
    'tablet dt': 'df-2640981140',
    'tablet pr': 'df-5771496195',
    'capsule sr': 'df-1673204773',
    'tablet er': 'df-2640981169',
    'dry syrup': 'df-6633941317',
    'oral suspension': 'df-6712141710',
    'eye drop': 'df-6923115097',
    shampoo: 'df-150499117',
    'capsule cr': 'df-1673204277',
    'oral solution': 'df-1398356916',
    powder: 'df-9603977956',
    'tablet cr': 'df-5771495792',
    suspension: 'df-6938132552',
    'transdermal patch': 'df-1819692448',
    'capsule er': 'df-1673204339',
    'mouth wash': 'df-1975273371',
    'tablet xl': 'df-5771496437',
    'nasal spray': 'df-9001195403',
    'solvent for injection': 'df-6639735669',
    respicap: 'df-9534391990',
    rotacap: 'df-4787871768',
    'tablet mr': 'df-9433355795',
    'ophthalmic solution': 'df-5596594528',
    'tablet xr': 'df-5771496443',
    'oral drops': 'df-4120857860',
    drop: 'df-2859918947',
    'ear drop': 'df-769375585',
    'tablet ir': 'df-5771495978',
    sachet: 'df-694631431',
    'suspension for injection': 'df-9785838630',
    'mouth paint': 'df-8590746745',
    'eye ointment': 'df-1728325352',
    'vaginal cream': 'df-2506911363',
    'oral gel': 'df-2912401248',
    'nasal solution': 'df-9961081561',
    solution: 'df-1451863148',
    'dental gel': 'df-797376788',
    infusion: 'df-374189216',
    expectorant: 'df-805057610',
    'rectal gel': 'df-4924674628',
    'eye gel': 'df-6602885500',
    soap: 'df-7836556548',
    'solution for infusion': 'df-1402596922',
    'tablet dr': 'df-927090512',
    'capsule mr': 'df-4007097071',
    'capsule dr': 'df-4007096792',
    'dusting powder': 'df-3529236065',
    kit: 'df-8217031281',
    liquid: 'df-9993424923',
    'eye/ear drops': 'df-1974770544',
    oil: 'df-8608641828',
    'prefilled syringe': 'df-9668524941',
    'sublingual tablet': 'df-1688382112',
    'vaginal gel': 'df-2185195660',
    transcaps: 'df-1970465927',
    'capsule pr': 'df-2643463364',
    'ophthalmic emulsion': 'df-3441448086',
    'chewable tablet': 'df-4850007708',
    wipes: 'df-4857666393',
    oxipule: 'df-9510666353',
    'eye cream': 'df-4147196478',
    'powder for oral suspension': 'df-4780496579',
    'ophthalmic gel': 'df-5459446376',
    'tablet vt': 'df-2126406054',
    'gum paint': 'df-8612103017',
    soflets: 'df-8208612521',
    toothpaste: 'df-8814284469',
    'rectal cream': 'df-733458396',
    'capsule tr': 'df-4007097288',
    'body wash': 'df-6628063675',
    film: 'df-1413258956',
    'effervescent tablet': 'df-2332183631',
    'capsule xl': 'df-5581681612',
    liniment: 'df-7062944040',
    elixir: 'df-6899457170',
    'capsule ir': 'df-5581681153',
    'vaginal capsule': 'df-9230242445',
    'tablet ops': 'df-1870425910',
    'opthalmic suspension': 'df-488828760',
    linctus: 'df-49277547',
    'oral liquid': 'df-4610327408',
    bar: 'df-2510839905',
    'tablet tr': 'df-2640981634',
    'capsule xr': 'df-4007097412',
    'disintegrating strip': 'df-4579193229',
    granules: 'df-2425753509',
    enema: 'df-6242474875',
    tabcap: 'df-4194933531',
    'vaginal spray': 'df-8139584503',
    pessaries: 'df-9672058462',
    scrub: 'df-6464983615',
    'mouth spray': 'df-2301953601',
    rheocap: 'df-8740451759',
    'tablet fc': 'df-2640981185',
    aquanase: 'df-8561854012',
    'powder for oral solution': 'df-9502229030',
    oxycap: 'df-8141538667',
    pellets: 'df-4132288505',
    'powder for eye drop': 'df-892432463',
    'vaginal suppository': 'df-3494767737',
    opticops: 'df-5940101371',
    'oral jelly': 'df-8820373639',
    'gelatin coated tablet': 'df-8870357367',
    paint: 'df-8668057458',
    paste: 'df-4482240240',
    'chewing gums': 'df-8035473675',
    foam: 'df-5915986529',
    bottle: 'df-9712763045',
    novocart: 'df-7602769613',
    'oral paste': 'df-5009101888',
    nexcap: 'df-8095332826',
    'vaginal ointment': 'df-6963584685',
    'rectal foam': 'df-3938940522',
    emulsion: 'df-2952738396',
    'face wash': 'df-1555529487',
    caplet: 'df-1277131046',
    particles: 'df-2301559214',
    ampules: 'df-4876426297',
    'intrauterine system': 'df-8954941358',
    husk: 'df-3624276106',
    pouch: 'df-964807772',
    transpules: 'df-2350212714',
    diskette: 'df-7062102740',
    'redimix suspension': 'df-6971888151',
    autohaler: 'df-4975687547',
    'rediuse suspension': 'df-3659458418',
    redicaps: 'df-9098309878',
    bandage: 'df-350518404',
    'powder for infusion': 'df-1661594237',
    gummy: 'df-5832289277',
    'nail lacquer': 'df-7785667552',
    pen: 'df-8689239835',
    pastilles: 'df-9322074283',
    'oral emulsion': 'df-9055674334',
    'combo pack': 'df-2742055965',
    serum: 'df-6409891484',
    device: 'df-9556291415',
    'rectal ointment': 'df-5202483433',
    vegicap: 'df-6559745513',
    'water for injection': 'df-9276666923',
    aplicap: 'df-3888208290',
    gum: 'df-9272193856',
    'sublingual spray': 'df-8601875703',
    cartridge: 'df-8771066655',
    'intranasal spray': 'df-9814665346',
    conditioner: 'df-4627026063',
    rapitab: 'df-7831429544',
    patch: 'df-7230132448',
    aerosol: 'df-3579023307',
    captab: 'df-3342490791',
    vial: 'df-4289419884',
    'vaginal wash': 'df-6442824734',
    'bio-adhesive': 'df-3660142317',
    instacap: 'df-2103416312',
    autopen: 'df-7831496676',
    cleanser: 'df-1846920497',
    multihaler: 'df-3474766597',
    transhaler: 'df-4479311395',

    // closest matches
    'mouth wash/gargle': 'df-1975273371',
    aplicaps: 'df-3888208290',
    pessary: 'df-9672058462',
    'soap/bar': 'df-7836556548',
    'powder(oral)': 'df-4780496579',
    'ear drops': 'df-769375585',
    'eye drops': 'df-6923115097',
    'medical devices': 'df-9556291415',
    'powder (topical)': 'df-9603977956',

    pill: 'df-9889335533',
};

export const SITE_OF_APPLICATION: { name: string; id: string }[] = [
    {
        name: 'Face',
        id: 'sm-2483258190',
    },
    {
        name: 'Scalp ',
        id: 'sm-5366019047',
    },
    {
        name: 'Eye',
        id: 'sm-5440487043',
    },
    {
        name: 'Skin',
        id: 'sm-5033840286',
    },
    {
        name: 'Tongue',
        id: 'sm-424801441',
    },
    {
        name: 'Ear',
        id: 'sm-8450158922',
    },
    {
        name: 'Genitals',
        id: 'sm-7984177921',
    },
    {
        name: 'Vagina',
        id: 'sm-2369055628',
    },
    {
        name: 'Rectal',
        id: 'sm-450256616',
    },
    {
        name: 'Gums ',
        id: 'sm-4812677819',
    },
    {
        name: 'Umbilicus',
        id: 'sm-1926920374',
    },
    {
        name: 'Nail',
        id: 'sm-3968435245',
    },
    {
        name: 'Abdomen',
        id: 'sm-9688607741',
    },
    {
        name: 'Nose',
        id: 'sm-8793235265',
    },
    {
        name: 'Hands',
        id: 'sm-8935001137',
    },
    {
        name: 'Leg',
        id: 'sm-390323755',
    },
    {
        name: 'Buttocks',
        id: 'sm-9857935816',
    },
    {
        name: 'Deltoid',
        id: 'sm-3171873002',
    },
    {
        name: 'Anterolateral Thigh',
        id: 'sm-1100193894',
    },
    {
        name: 'Nostril',
        id: 'sm-8007648072',
    },
    {
        name: 'Finger Web',
        id: 'sm-8628574074',
    },
    {
        name: 'Abdomen Skin',
        id: 'sm-1282041623',
    },
    {
        name: 'Arm',
        id: 'sm-4503881167',
    },
    {
        name: 'Joints',
        id: 'sm-4863763470',
    },
    {
        name: 'Foot',
        id: 'sm-7255318342',
    },
    {
        name: 'Back',
        id: 'sm-3197573137',
    },
    {
        name: 'Neck',
        id: 'sm-8739730627',
    },
    {
        name: 'Under The Eyes',
        id: 's-7299110394',
    },
    {
        name: 'Pinna',
        id: 'sm-4836629782',
    },
    {
        name: 'Forehead ',
        id: 'sm-7379146284',
    },
    {
        name: 'Shoulder',
        id: 'sm-7350569669',
    },
    {
        name: 'Chest',
        id: 'sm-2734563887',
    },
    {
        name: 'Nipple',
        id: 'sm-2855449126',
    },
    {
        name: 'Groin',
        id: 'sm-4835507946',
    },
    {
        name: 'Knee',
        id: 'sm-8791394856',
    },
    {
        name: 'Ankle',
        id: 'sm-9022320703',
    },
    {
        name: 'Shin',
        id: 'sm-3996299631',
    },
    {
        name: 'Wrist',
        id: 'sm-4068656817',
    },
    {
        name: 'Finger',
        id: 'sm-3272700877',
    },
    {
        name: 'Thumb',
        id: 'sm-2304438952',
    },
    {
        name: 'Toes',
        id: 'sm-7461197313',
    },
    {
        name: 'Heel',
        id: 'sm-2394884430',
    },
    {
        name: 'Low Back',
        id: 'sm-3229131301',
    },
    {
        name: 'Scalp Hair',
        id: 'sm-7826034332',
    },
];

export const ROUTES: MedRoute[] = [
    {
        name: 'Oral',
        id: 'sm-32048621',
        display_name: 'PO',
        snomed_id: '26643006',
    },
    {
        name: 'Subcutaneous',
        id: 'sm-6844626183',
        display_name: 'SC',
        snomed_id: '34206005',
    },
    {
        name: 'Intradermal',
        id: 'sm-3292784729',
        display_name: 'Intradermal',
        snomed_id: '372464004',
    },
    {
        name: 'Intravenous',
        id: 'sm-3807992832',
        display_name: 'IV',
        snomed_id: '47625008',
    },
    {
        name: 'Infusion',
        id: 'sm-9103805958',
        display_name: 'Infusion',
        snomed_id: '36576007',
    },
    {
        name: 'Ear',
        id: 'sm-1023703',
        display_name: 'Ear',
        snomed_id: '10547007',
    },
    {
        name: 'Eye',
        id: 'sm-1024434',
        display_name: 'Eye',
        snomed_id: '54485002',
    },
    {
        name: 'Vagina',
        id: 'sm-983608354',
        display_name: 'Vaginal',
        snomed_id: '16857009',
    },
    {
        name: 'Rectal',
        id: 'sm-872676849',
        display_name: 'Rectal',
        snomed_id: '37161004',
    },
    {
        name: 'Nose',
        id: 'sm-32016498',
        display_name: 'Nasal',
        snomed_id: '46713006',
    },
    {
        name: 'Sublingual',
        id: 'sm-6896530370',
        display_name: 'Sublingual',
        snomed_id: '37839007',
    },
    {
        name: 'Inhalational',
        id: 'sm-7860170508',
        display_name: 'Inhalational',
        snomed_id: '447694001',
    },
    {
        name: 'Intramuscular',
        id: 'sm-6199703688',
        display_name: 'IM',
        snomed_id: '78421000',
    },
    {
        name: 'Intraarticular',
        id: 'sm-6003455176',
        display_name: 'Intraarticular',
        snomed_id: '12130007',
    },
    {
        name: 'Intraosseous',
        id: 'sm-2240374256',
        display_name: 'Intraosseous',
        snomed_id: '417255000',
    },
    {
        name: 'Intralesional',
        id: 'sm-4492394973',
        display_name: 'Intralesional',
        snomed_id: '372466002',
    },
    {
        name: 'Intraperitoneal',
        id: 'sm-8312061577',
        display_name: 'Intraperitoneal',
        snomed_id: '38239002',
    },
    {
        name: 'Nasogastric',
        id: 'sm-9463224139',
        display_name: 'NG',
        snomed_id: '127492001',
    },
    {
        name: 'Gastrostomy route',
        id: 'sm-5785311029',
        display_name: 'Gastrostomy',
        snomed_id: '127490009',
    },
    {
        name: 'Intraamniotic',
        id: 'sm-8810529420',
        display_name: 'Intraamniotic',
        snomed_id: '372458006',
    },
    {
        name: 'Intralesional',
        id: 'sm-4492394973',
        display_name: 'Intralesional',
        snomed_id: '372466002',
    },
    {
        name: 'Intrathecal',
        id: 'sm-3753224815',
        display_name: 'Intrathecal',
        snomed_id: '72607000',
    },
    {
        name: 'Epidural',
        id: 'sm-898612257',
        display_name: 'Epidural',
        snomed_id: '404820008',
    },
    {
        name: 'Intraspinal',
        id: 'sm-3732113567',
        display_name: 'Intraspinal',
        snomed_id: '418418000',
    },
    {
        name: 'Intrathoracic',
        id: 'sm-7149186605',
        display_name: 'Intrathoracic',
        snomed_id: '417950001',
    },
    {
        name: 'Intratracheal',
        id: 'sm-5609772707',
        display_name: 'Intratracheal',
        snomed_id: '404818005',
    },
    {
        name: 'Topical',
        id: 'sm-9125960954',
        display_name: 'Topical',
        snomed_id: '6064005',
    },
    {
        name: 'Transdermal',
        id: 'sm-3934025196',
        display_name: 'Transdermal',
        snomed_id: '45890007',
    },
];
